<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Picker</em>
				<span class="int_type_no_border mgr_5">
					<input
						type="text"
						ref="picker_barcode"
						v-model.trim="picker_barcode"
						class="tbl_int"
						style="width:154px;"
						placeholder="Scan Picker's Barcode"
						autofocus
						autocomplete="off"
						@keypress.enter="searchPicker()"
						@focus="picker_focus = true"
						@blur="picker_focus = false"
					/>
					<span class="int_type">
						<select v-model="picker_barcode" @change="pickerChanged()">
							<option :value="null">Select Staff</option>
							<!-- <option v-for="(staff, index) in wh_staff_list" :key="index" :value="staff.barcode">{{ staff.barcode }} | {{ staff.name }} ({{ staff.user_id }})</option> -->
							<option v-for="(staff, index) in wh_staff_list" :key="index" :value="staff.barcode">{{ staff.name }} ({{ staff.user_id }}) | {{ staff.barcode }}</option>
						</select>
					</span>
					<input type="text" v-model.trim="picker_name" class="tbl_int" style="color:blue;width:266px;" disabled />
					<!-- <template v-if="picker_id"
						><font color="blue">{{ picker_id }}</font> (<b>{{ picker_name }}</b
						>)</template
					> -->
				</span>
				<label for="designated" style="margin-left:5px;" class="mgr_15"> <input type="checkbox" id="designated" v-model="designated" />Designated / Batch</label>
				<span v-if="designated" class="int_type_no_border mgr_5">
					<input type="text" v-model.trim="designated_so_dn" class="tbl_int" style="width:200px;" placeholder="Scan Barcode of Designated SO" @focus="$event.target.select()" @keypress.enter="pickupDesignated()" />
				</span>
				<!-- * Scan the picker's barcode, if the picker is not the login user ({{ user.name }}) -->
			</div>
			<div class="left_option" style="padding-top:5px;">
				<em class="lt_text">Sales Order / Sample No</em>
				<span class="int_type_no_border mgr_5">
					<!-- <input type="text" v-model.trim="sono" placeholder="Enter SO No or Scan Barcode" autofocus autocomplete="off" /> -->
					<!-- <SoSelect v-model.trim="so_dn" initialStatusCode="P" ph="Enter SO No or Scan Barcode" @set-invoice="setInvoice" @search="search()" /> -->
					<!-- <SoSelect ref="so_dn" v-model.trim="so_dn" initialStatusCode="P" ph="Enter No or Scan" @set-invoice="setInvoice" @search="search()" /> -->
					<input type="text" ref="so_dn" v-model.trim="so_dn" class="tbl_int" style="width:154px;" placeholder="Enter No or Scan" autofocus autocomplete="off" @keypress.enter="search()" />
				</span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt mgr_15" @click="reset()">Reset</a>

				<a href="javascript:;" class="gray_bt" @click="pickUpHistoryModal()">Pick up History</a>

				<span v-if="!is_sample && pickerUpdatable" style="margin-left:50px;">
					<a href="javascript:;" class="gray_bt" @click="changePicker()">Update picker</a>
				</span>

				<span v-if="pickupStatuses.length > 0" style="margin-left:50px;">
					<a href="javascript:;" class="gray_bt" @click="deletePickupInfo()">Delete Pickup Information</a>
				</span>

				<span v-if="is_sample && sample.status_code == 'D'" style="margin-left:50px;">
					<a href="javascript:;" class="gray_bt" @click="salesmanPickup()">Salesman Pick Up</a>
				</span>
			</div>
		</div>
		<div class="view_inner">
			<div class="divide_tbl">
				<table v-if="!is_sample" class="view_tbl" border="0">
					<colgroup>
						<col style="width:130px;" />
						<!-- <col style="width:400px;" /> -->
						<col style="" />
						<col style="width:130px;" />
						<col style="" />
					</colgroup>
					<tbody>
						<tr>
							<th>Sales Date</th>
							<td>
								<input type="text" class="tbl_int ssm_int" v-model="invoice.so_date" readonly />
							</td>
							<th>Ship To</th>
							<td>
								<!-- <PartnerSelect v-model="invoice.ship_to_code" :initialName="invoice.ship_to_name" ph="Ship To" /> -->
								<div style="float:left;"><PartnerSelect v-model="invoice.ship_to_code" :initialName="invoice.ship_to_name" ph="Ship To" disabled="disabled" /></div>
								<!-- <div style="float:right;"><button @click="copy_ship_to_bill()">=></button></div> -->
							</td>
						</tr>
						<tr>
							<th>Ship To Address</th>
							<td colspan="3">
								<input type="text" list="addresses" class="tbl_int full_int" v-model.trim="invoice.ship_to_address1" readonly />
							</td>
						</tr>
						<tr>
							<th>To Accounting</th>
							<td>
								<input type="text" v-model.trim="invoice.remark" class="tbl_int" placeholder="To Approval or Invoice Staff" readonly />
								<!-- <div style="float:left;"><input type="text" v-model.trim="invoice.remark" class="tbl_int sm_int" @input="updateRemark" /></div>
								<div style="float:left;padding-left:5px;">
									<CodeSelect className="tbl_select" :codes="remarks" :width="60" :showDesc="false" v-model="remark" @set-code="setRemark" />
								</div> -->
							</td>
							<th>To Warehouse Staff</th>
							<td>
								<input type="text" v-model.trim="invoice.remark2" class="tbl_int" placeholder="To Warehouse Staff" readonly />
							</td>
						</tr>
					</tbody>
				</table>
				<table v-if="is_sample" class="view_tbl" border="0">
					<colgroup>
						<col style="width:130px;" />
						<!-- <col style="width:400px;" /> -->
						<col style="width:120px;" />
						<col style="width:80px;" />
						<col style="" />
					</colgroup>
					<tbody>
						<tr>
							<th>Sample Request Date</th>
							<td>
								<input type="text" class="tbl_int ssm_int" v-model="sample.request_date" readonly />
							</td>
							<th>Sales Group</th>
							<td>
								<input type="text" class="tbl_int sm_int mgr_15" v-model="sample.sales_group_name" readonly />
								<a v-if="sample.sample_no" href="javascript:;" @click="openSample()">Sample Detail (Click)</a>
							</td>
						</tr>
						<tr>
							<th>Status</th>
							<td>
								<input type="text" class="tbl_int sm_int" :value="sample.status_code | sampleStatusName" readonly />
							</td>
							<template v-if="sample.status_code == 'P'">
								<th>Pickup</th>
								<td>
									<input type="text" v-model.trim="sample.pickup_date" class="tbl_int ssm_int" readonly />
									by {{ sample.pickup_user }} at {{ sample.pickup_dt | moment('HH:mm:ss') }}
								</td>
							</template>
						</tr>
						<tr>
							<th>Description</th>
							<td colspan="3">
								<input type="text" v-model.trim="sample.description" class="tbl_int" readonly />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<!-- <div>
			<h3>SO 번호로 바코드 스캐닝 가능함****</h3>
			<br />
		</div> -->

		<!-- <div>Invoice No : {{ invoice ? invoice.invoice_no : null }}</div>
		<div>Sales Date : {{ invoice ? invoice.so_date : null }}</div>
		<div>Ship To : {{ invoice ? invoice.ship_to_code : null }}</div> -->

		<table class="list_tbl">
			<thead>
				<tr>
					<!-- <th width="2%"><input type="checkbox" @change="selectAll()" v-model="allSelected" /></th> -->
					<th width="10%">Location Code</th>
					<th width="10%">Location Name</th>
					<th v-if="company_id == 'jc'" width="10%">Rack / Section / Qty</th>
					<th width="10%">Quantity</th>
					<th width="10%">Picker ID</th>
					<th width="15%">Picker Name</th>
					<th width="18%">
						Start Time
						<a v-if="modifiable && (!is_sample || sample.status_code == 'A')" href="javascript:;" type="button" class="search_bt" style="margin-left:10px;margin-top:-5px;" @click="pickupStartBatch()">Start All</a>
					</th>
					<th width="18%">
						End Time
						<a v-if="modifiable && (!is_sample || sample.status_code == 'A')" href="javascript:;" type="button" class="search_bt" style="margin-left:10px;margin-top:-5px;" @click="pickupCompleteBatch()">Complete All</a>
					</th>
				</tr>
			</thead>

			<tbody>
				<tr v-for="status in pickupStatuses" v-bind:key="status.location_code">
					<td class="al_left" style="padding-top:15px;padding-bottom:15px;">{{ status.location_code }}</td>
					<td class="al_left">{{ status.location_name }}</td>
					<td v-if="company_id == 'jc'" class="al_left">
						<table v-if="getRackSectionQuantities(status.location_code).length > 0" class="list_tbl">
							<colgroup>
								<col style="width:100px;" />
								<col style="width:100px;" />
								<col style="width:50px;" />
							</colgroup>
							<tbody>
								<tr v-for="(rsq, index) in getRackSectionQuantities(status.location_code)" v-bind:key="index">
									<td>{{ rsq.rack }}</td>
									<td>{{ rsq.section }}</td>
									<td class="al_right">{{ rsq.item_quantity }}</td>
								</tr>
							</tbody>
						</table>
					</td>
					<td class="al_right">{{ status.quantity | commaSeparated }}</td>
					<td class="al_left">{{ status.picker_id }}</td>
					<td class="al_left">{{ status.picker_name }}</td>
					<td class="al_center">
						<template v-if="status.start_dt">
							{{ status.start_dt | moment('MM-DD-YYYY HH:mm:ss') }}
						</template>
						<template v-else-if="status.quantity">
							<a v-if="modifiable && !is_sample" href="javascript:;" type="button" class="search_bt" @click="pickupStart(status)">Start</a>
						</template>
					</td>
					<td class="al_center">
						<template v-if="status.end_dt">
							{{ status.end_dt | moment('MM-DD-YYYY HH:mm:ss') }}
						</template>
						<template v-else-if="status.start_dt">
							<a v-if="modifiable && !is_sample" href="javascript:;" type="button" class="search_bt" @click="pickupComplete(status)">Complete</a>
						</template>
					</td>
				</tr>
			</tbody>
		</table>

		<!-- <div class="view_bottom_bt">
			<a href="javascript:;" type="button" :class="invoice ? 'search_bt' : 'disable_bt'" @click="completePickUp()">Complete Pick Up</a>
		</div> -->

		<input type="hidden" id="barcode_data" />
		<input type="hidden" id="code-scan" />

		<SearchPickUp v-if="is_pickup_history" @close="is_pickup_history = false" />
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
//import { initBarcodeScanner } from '@/utils/barcode.js';
import { apiSelectInvoice } from '@/api/sales/invoice.js';
import { apiPickupStart, apiPickupComplete, apiPickupStartBatch, apiPickupCompleteBatch, apiPickupDesignated, apiChangePicker, apiDeletePickupInfo, apiCheckPickingOrder } from '@/api/sales/pickup.js';
//import { apiPickupCompleteBatch, apiPickupStartBatch, apiSelectSample, apiUpdateSalesmanPickup } from '@/api/sales/sample.js';
import { apiSamplePickupStartBatch, apiSamplePickupCompleteBatch, apiUpdateSalesmanPickup, apiSampleDeletePickupInfo } from '@/api/sales/sample.js';
import { apiSelectUserList } from '@/api/basicinfo/user.js';
// import SoSelect from '@/components/common/SoSelect';
//import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import PartnerSelect from '@/components/common/PartnerSelect';
import SearchPickUp from '@/components/common/SearchPickUp';
//import Modal from '@/components/common/Modal';
//import { today, daysAgo } from '@/utils/date.js';

export default {
	data: function() {
		return {
			backUri: '/',
			so_dn: null,
			invoice: {},
			sample_dn: null,
			sample: {},

			itemList: [],

			searching: false,

			picker_barcode: null,
			picker_id: null,
			picker_name: null,
			picking_order_list: [], // [{ invoice_no, so_dn }] beautyplus는 기존에 작업중인 Sales Order가 있는 경우, 새로운 Sales Order에 대한 작업을 시작하지 못하도록 함.

			pickupStatuses: [],
			wh_staff_list: [],

			rackSectionItemQuantities: [],

			picker_focus: true,

			designated: false,
			designated_so_dn: null,

			is_sample: false,
			is_pickup_history: false,
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : null;
		},
		must_complete_prev_order() {
			return ['beautyplus'].includes(this.company_id);
		},
		pickerUpdatable() {
			if (!this.picker_id) return false;

			return this.pickupStatuses.filter(s => s.picker_id).length > 0 ? true : false;
		},
	},
	// watch: {
	// 	barcode_data: function(newVal) {
	// 		console.log('Hmmm', newVal);
	// 		if (newVal) {
	// 			this.sono = newVal;
	// 		}
	// 	},
	// },
	components: {
		// SoSelect,
		//CustomDatePicker,
		PartnerSelect,
		SearchPickUp,
	},
	methods: {
		getRackSectionQuantities(location_code) {
			return this.rackSectionItemQuantities.filter(i => i.location_code == location_code);
		},
		pickUpHistoryModal() {
			this.is_pickup_history = true;
		},
		openSample() {
			let routeData = this.$router.resolve({ name: 'sampleDetail', params: { mode: 'detail' }, query: { backUri: this.uri, sample_no: this.sample.sample_no } });
			window.open(routeData.href, 'herp_sample_detail');
		},
		async salesmanPickup() {
			const { data } = await apiUpdateSalesmanPickup({
				sample_no: this.sample.sample_no,
			});

			if (data.result) {
				this.$toast.success('Saved Successfully');
				this.search();
			} else {
				this.$toast.error(data.msg);
			}
		},
		cannot_accept_order() {
			if (this.must_complete_prev_order && this.picking_order_list.length > 0 && this.picking_order_list.findIndex(o => o.invoice_no === this.invoice.invoice_no) < 0) {
				let msg = this.picker_id + '(' + this.picker_name + ') should complete the previous order<br />and continue this order.<br />Prev. S/O: ';
				msg += this.picking_order_list.map(o => o.so_dn).join(',');
				this.$alertify.alert('Alert', msg);
				return true;
			} else return false;
		},
		isValid() {
			if (!this.picker_id) {
				this.$toast.error('Picker not specified');
				return false;
			}
			return true;
		},
		isCompletable(status) {
			//console.log(this.picker_id, status);
			if (this.picker_id != status.picker_id) {
				this.$toast.error('Picker is different. Update first.');
				return false;
			}

			return true;
		},
		isAllCompletable() {
			//console.log(this.pickupStatuses);
			var rv = true;
			var vm = this;
			this.pickupStatuses.forEach(s => {
				if (rv && s.picker_id && vm.picker_id != s.picker_id) {
					vm.$toast.error('Picker is different. Update first.');
					rv = false;
					return false;
				}
			});

			return rv;
		},
		pickerChanged() {
			//console.log(this.picker_barcode);
			if (this.picker_barcode) {
				//console.log(this.picker_barcode);
				this.searchPicker();
			}
		},
		async searchPicker() {
			if (!this.picker_barcode) return;

			const { data } = await apiCheckPickingOrder(this.picker_barcode);
			//console.log(data.user);
			if (data) {
				this.picker_id = data.user_id;
				this.picker_name = data.name;
				this.picking_order_list = data.picking_order_list;
				//console.log(this.$refs.so_dn);
				//this.$refs.so_dn.$el.firstChild.focus();
				this.$refs.so_dn.focus();
			} else {
				this.$toast.error('Barcode : ' + this.picker_barcode + ' not found');
				this.picker_id = null;
				this.picker_name = null;
				this.picker_barcode = null;
				this.picking_order_list = [];
			}
		},
		// async completePickUp() {
		// 	if (!this.invoice) return;
		// 	//console.log('Complete Pickup');
		// },
		reset() {
			this.picker_barcode = null;
			this.picker_name = null;
			this.picker_id = null;
			this.picking_order_list = [];
			this.invoice = {};
			this.so_dn = null;
			this.sample = {};
			this.sample_dn = null;
			this.pickupStatuses = [];

			this.$refs.picker_barcode.focus();
		},
		setInvoice() {
			this.search();
		},
		async pickupDesignated() {
			if (!this.designated_so_dn) {
				this.$toast.error('Empty So No.');
				return;
			}

			if (!this.picker_id) {
				this.$toast.error('Picker not specified');
				return;
			}

			if (this.cannot_accept_order()) return;

			const { data } = await apiPickupDesignated({
				so_dn: this.designated_so_dn,
				picker_id: this.picker_id,
			});

			if (data.result) {
				this.$toast.success('SO No : ' + this.designated_so_dn + ' Processed Successfully');
				this.designated_so_dn = null;
			} else {
				this.$toast.error(data.msg);
			}

			//console.log(data);
		},
		async search() {
			if (this.searching) return;

			//this.searching = true;
			//console.log('search');
			if (!this.so_dn) {
				this.$toast.error('Empty So No.');
				return;
			}

			// if (!this.picker_id) {
			// 	this.$toast.error('Picker not specified');
			// 	return;
			// }

			this.searching = true;
			//console.log('Searching SO:', this.sono);
			const { data } = await apiSelectInvoice({
				//invoice_no: this.invoice.invoice_no,
				so_dn: this.so_dn,
				status_code: 'P',
				for_pickup: true,

				include_sample: true,
			});
			//console.log(data.invoice);

			this.pickupStatuses = [];
			this.itemList = [];

			this.invoice = data.invoice;
			if (!this.invoice) {
				//this.$toast.error('Not found or not in packing status.');
				this.invoice = {};

				this.sample = data.sample;
				if (!this.sample) {
					this.$toast.error('Not found or not in packing status.');
					this.sample = {};
				} else {
					this.is_sample = true;
					this.pickupStatuses = data.pickupStatusList;

					this.itemList = data.sampleItemList;
					//console.log(this.pickupStatuses);
				}
			} else {
				this.is_sample = false;
				this.sample = {};
				this.pickupStatuses = data.pickupStatusList;

				this.itemList = data.invoiceItemList;
				this.rackSectionItemQuantities = data.rackSectionItemQuantityList;
				//console.log(this.pickupStatuses);
				//console.log(this.itemList);
				//console.log(data);
				console.log(this.rackSectionItemQuantities);
			}
			this.searching = false;
			// 위에서 return이 발생하는 경우가 존재하므로, search메서드 실행 후 searchPicker 메서드를 실행하는 걸로 코드수정
			// if (this.must_complete_prev_order && this.picker_barcode) this.searchPicker();
			//console.log(this.invoice);
			//this.items = data.invoiceItemList;
			//this.selectInvoices();
		},
		async deletePickupInfo() {
			//console.log(this.picker_id);
			if (confirm('Are you sure to delete the pickup information?')) {
				// const { data } = await apiDeletePickupInfo({
				// 	invoice_no: this.invoice.invoice_no,
				// });

				var response;

				if (!this.is_sample)
					response = await apiDeletePickupInfo({
						invoice_no: this.invoice.invoice_no,
					});
				else
					response = await apiSampleDeletePickupInfo({
						sample_no: this.sample.sample_no,
					});

				var data = response.data;

				if (data.result) {
					this.$toast.success('Deleted Successfully');
					await this.search();
					if (this.must_complete_prev_order && this.picker_barcode) this.searchPicker();
				} else {
					this.$toast.error(data.msg);
				}
			}
		},
		async changePicker() {
			if (this.cannot_accept_order()) return;

			const { data } = await apiChangePicker({
				invoice_no: this.invoice.invoice_no,
				picker_id: this.picker_id,
			});

			if (data.result) {
				this.$toast.success('Saved Successfully');
				await this.search();
				if (this.must_complete_prev_order && this.picker_barcode) this.searchPicker();
			} else {
				this.$toast.error(data.msg);
			}
		},
		async pickupStartBatch() {
			if (this.cannot_accept_order()) return;

			var valids = this.pickupStatuses.filter(l => l.quantity > 0 && !l.start_dt);

			if (valids.length > 0) {
				if (!this.isValid()) return;

				var response;

				if (!this.is_sample)
					response = await apiPickupStartBatch({
						invoice_no: this.invoice.invoice_no,
						items: valids,
						picker_id: this.picker_id,
					});
				else
					response = await apiSamplePickupStartBatch({
						sample_no: this.sample.sample_no,
						items: valids,
						picker_id: this.picker_id,
					});

				var data = response.data;
				// const { data } = await apiPickupStartBatch({
				// 	invoice_no: this.invoice.invoice_no,
				// 	items: valids,
				// 	picker_id: this.picker_id,
				// });

				if (data.result) {
					this.$toast.success('Saved Successfully');
					await this.search();
					if (this.must_complete_prev_order && this.picker_barcode) this.searchPicker();

					var vm = this;
					setTimeout(function() {
						vm.reset();
					}, 10000);
				} else {
					this.$toast.error(data.msg);
				}
			} else {
				this.$toast.error('Noting to process');
			}
		},
		async pickupCompleteBatch() {
			var valids = this.pickupStatuses.filter(l => l.start_dt && !l.end_dt);

			if (valids.length > 0) {
				if (!this.isValid()) return;
				if (!this.isAllCompletable()) return;
				//console.log(valids);

				var response;

				if (!this.is_sample)
					response = await apiPickupCompleteBatch({
						invoice_no: this.invoice.invoice_no,
						valid_items: valids,
						picker_id: this.picker_id,
					});
				else
					response = await apiSamplePickupCompleteBatch({
						sample_no: this.sample.sample_no,
						valid_items: valids,
						picker_id: this.picker_id,
						// sample_item 및 inventory update를 위해 param에 추가
						items: this.itemList,
					});

				var data = response.data;

				// const { data } = await apiPickupCompleteBatch({
				// 	invoice_no: this.invoice.invoice_no,
				// 	items: valids,
				// 	picker_id: this.picker_id,
				// });

				if (data.result) {
					this.$toast.success('Saved Successfully');
					await this.search();
					if (this.must_complete_prev_order && this.picker_barcode) this.searchPicker();

					var vm = this;
					setTimeout(function() {
						vm.reset();
					}, 10000);
				} else {
					this.$toast.error(data.msg);
				}
			} else {
				this.$toast.error('Noting to process');
			}
		},
		async pickupStart(status) {
			if (this.cannot_accept_order()) return;
			if (!this.isValid()) return;

			const { data } = await apiPickupStart({
				invoice_no: this.invoice.invoice_no,
				location_code: status.location_code,
				picker_id: this.picker_id,
			});

			if (data.result) {
				this.$toast.success('Saved Successfully');
				await this.search();
				if (this.must_complete_prev_order && this.picker_barcode) this.searchPicker();

				//this.$router.push(this.backUri);
			} else {
				this.$toast.error(data.msg);
			}
		},
		async pickupComplete(status) {
			if (!this.isValid()) return;
			if (!this.isCompletable(status)) return;

			const { data } = await apiPickupComplete({
				invoice_no: this.invoice.invoice_no,
				location_code: status.location_code,
				picker_id: this.picker_id,
			});

			if (data.result) {
				this.$toast.success('Saved Successfully');
				await this.search();
				if (this.must_complete_prev_order && this.picker_barcode) this.searchPicker();

				//this.$router.push(this.backUri);
			} else {
				this.$toast.error(data.msg);
			}
		},
		async index() {
			// const { data } = await apiIndex();
			// this.locations = data.locationList;
			// console.log(this.locations);
		},
		async init() {
			let { data } = await apiSelectUserList({
				active_yn: 'Y',
				user_type: 'whstaff',
				sort_key: 'user_name',
			});

			this.wh_staff_list = data.userList;
			this.wh_staff_list.forEach(u => {
				u.barcode = u.barcode.substring(0, 10);
			});
			//console.log(this.wf_staff_list);
			//await this.index();
			//if (this.$route.query.sono) this.sono = this.$route.query.sono;
			//await this.selectInvoices();
		},
		barcodeScanned() {
			if (this.picker_focus) return;
			//console.log('Hm.....', this.barcode_data);
			var barcode_data = $('#barcode_data').val();

			if (barcode_data) {
				// if (this.invoice) {
				// 	console.log('search item');
				// } else {
				// 	this.sono = barcode_data;
				// 	this.search();
				// }
				this.so_dn = barcode_data;
				this.search();
			}
			//console.log('Hm.....', this.barcode_data);
		},
	},
	created() {
		//this.$store.sideIndex = 3;
		this.$store.commit('setSideIndex', 3);
		//this.$store.selectedMenu = 'nav_li_6';
		this.$store.commit('setSelectedMenu', 'nav_li_pickup');
		this.$store.commit('setSubTitle', 'Sales -> Pick Up for Packing');

		//this.selectInvoices();
		this.init();
		//this.invoice.invoice_date = this.$moment(new Date()).format('MM-DD-YYYY');
		//this.invoice.so_date = today();
		//console.log(this.$moment(new Date()).format('MM-DD-YYYY HH:mm:ss'));

		//console.log(this.$session.get('time_zone'));
		//this.$moment.tz.setDefault(this.$session.get('time_zone'));
	},
	mounted() {
		inputSelectOnClick();
		//initBarcodeScanner();
		//document.addEventListener('barcode_scanned', this.barcodeScanned);

		this.$refs.picker_barcode.focus();
	},
	destroyed() {
		//document.removeEventListener('barcode_scanned', this.barcodeScanned);
	},
};
</script>

<style></style>
